module.exports = __webpack_public_path__ + "static/media/del_btn_line.56600556.svg";